import { AppVersionActionTypes } from './constants';
import { AppVersionDetails, UpdateAppVersionDetails } from 'helpers/api/appVersions';

export type AppVersionActionType = {
    type:
        | AppVersionActionTypes.API_RESPONSE_SUCCESS
        | AppVersionActionTypes.API_RESPONSE_ERROR
        | AppVersionActionTypes.GET_APP_VERSIONS
        | AppVersionActionTypes.GET_APP_VERSION_BY_ID
        | AppVersionActionTypes.CREATE_APP_VERSION
        | AppVersionActionTypes.UPDATE_APP_VERSION
        | AppVersionActionTypes.DELETE_APP_VERSION
        | AppVersionActionTypes.RESET;
    payload: {} | string;
};

// Common success
export const appVersionApiResponseSuccess = (actionType: string, data: any): AppVersionActionType => ({
    type: AppVersionActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

// Common error
export const appVersionApiResponseError = (actionType: string, error: string): AppVersionActionType => ({
    type: AppVersionActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

// Get all app versions
export const getAppVersions = (): AppVersionActionType => ({
    type: AppVersionActionTypes.GET_APP_VERSIONS,
    payload: {},
});

// Get app version by ID
export const getAppVersionById = (id: number): AppVersionActionType => ({
    type: AppVersionActionTypes.GET_APP_VERSION_BY_ID,
    payload: { id },
});

// Create (upsert) app version
export const createAppVersion = (data: AppVersionDetails): AppVersionActionType => ({
    type: AppVersionActionTypes.CREATE_APP_VERSION,
    payload: data,
});

// Update app version
export const updateAppVersion = (id: number, data: UpdateAppVersionDetails): AppVersionActionType => ({
    type: AppVersionActionTypes.UPDATE_APP_VERSION,
    payload: { id, data },
});

// Delete app version
export const deleteAppVersion = (id: number): AppVersionActionType => ({
    type: AppVersionActionTypes.DELETE_APP_VERSION,
    payload: { id },
});

// Reset state
export const resetAppVersions = (): AppVersionActionType => ({
    type: AppVersionActionTypes.RESET,
    payload: {},
});
